// Sentry MUST be the first import so its global error / unhandledrejection
// hooks are registered before any other module-load code can throw.
import "@/sentry.instrument";

import React from "react";
import ReactDOM from "react-dom/client";
import { GoogleOAuthProvider } from "@react-oauth/google";
import "@/index.css";
// Side-effect import: registers the global Idempotency-Key interceptor on
// axios. Must happen before any component fires a POST/PUT/PATCH.
import "@/utils/api";
import App from "@/App";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={googleClientId}>
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>,
);
